import { request } from '@/utils/request'

const prefix = '/app'

export function getUsers () {
  return request({
    url: `${prefix}/users`,
    method: 'get'
  })
}
/**
 * Save list with users
 *
 * @param user is json object {fullName, login, role, email, phone, ports, [userId]}
 * @returns { promise }
 */
export function saveUser(user) {
  document.MeridianVue.debug && console.log(user)
  let url = user.id ? `${prefix}/users/${user.id}` : `${prefix}/users`
  document.MeridianVue.debug && console.log(url)
  return request({
    url: url,
    method: 'post',
    data: user
  })
}
/**
 * Delete user
 *
 * @param deletedUserId is string
 * @returns { promise }
 */
export function deleteUser(deletedUserId) {
  return request({
    url: `${prefix}/users/${deletedUserId}`,
    method: 'delete'
  })
}
/**
 * update password user
 *
 * @param userId
 * @param pass
 * @returns { promise }
 */
export function updatePassword(userId, password) {
  return request({
    url: `${prefix}/users/pass`,
    method: 'post',
    data: { userId, password }
  })
}
export function generateNewPassword(userId) {
  return request({
    url: `${prefix}/users/pass/${userId}/generate`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/rest/users.js